import styled from 'styled-components';
import colors from 'styles/colors';

import { Input } from 'styles/form';

export const Title = styled.h3`
  font-size: 14px;
  line-height: 19px;
  color: ${colors.primary};
  font-weight: 600;
`;

export const NoFiltersMessage = styled.p`
  font-size: 12px;
  line-height: 17px;
  margin: 0;
`;

export const ChooseFilter = styled.div`
  margin: 15px 0;
`;

export const FilterFormContainer = styled.div`
  border-top: 1px solid ${colors.primary};
`;

export const FilterFormTitle = styled.h4`
  font-size: 12px;
  line-height: 17px;
  font-weight: 600;
`;

export const FilterItemGroup = styled.div`
  margin-bottom: 10px;
`;

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 17px;
  cursor: pointer;

  span {
    margin-left: 10px;
    font-size: 12px;
    text-transform: none;
  }
`;

export const FilterInput = styled(Input)`
  width: 100%;
  display: block;
  margin: 10px 0 20px 0;
`;

export const FilterDropdownContainer = styled.div`
  margin: 10px 0 20px 0;
`;

export const AppliedFilterContainer = styled.div`
  padding: 10px 40px 10px 15px;
  font-size: 11px;
  line-height: 15px;
  background-color: ${colors.filterBackground};
  margin-bottom: 10px;
  position: relative;
`;

export const AppliedFilterValue = styled.span`
  font-weight: 700;
`;

export const CloseIcon = styled.i`
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
  align-content: space-between;
  display: flex;
  margin-top: 30px;
`;
